<template>
  <div class="row">
    <div class="col-lg-12">
      <div class="card">
        <div class="card-header py-0">
          <a-row
            class='py-2'
          >
            <a-col
              :sm='24'
              :lg='20'
              class='pr-1'
            >
              <a-input
                style="width: 100%"
                placeholder="Buscar..."
                @keyup.enter="getCatalogs(10, 0, searchText)"
                v-model:value="searchText"
              />
            </a-col>
            <a-col
              :sm='24'
              :lg='4'
              class='pl-1'
            >
              <button
                class="btn bg-holcim-bright-green text-white"
                @click="getCatalogs(10, 0, searchText)"
                style="width: 100%"
              >
                <i class="fe fe-refresh-cw" />
                Buscar
              </button>
            </a-col>
          </a-row>
        </div>
        <div class="card-body">
          <catalog-table
            :data="catalogs"
            :loading="tableLoading"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import CatalogTable from './components/CatalogTable'
import { reactive } from 'vue'
import useCatalog from '../../composables/useCatalog'

export default {
  name: 'CatalogMain',
  components: {
    CatalogTable,
  },
  setup() {

    const {
      searchText,
      catalogs,
      tableLoading,
      getCatalogs,
    } = useCatalog()

    return {
      searchText,
      catalogs,
      tableLoading,
      getCatalogs,
    }

  },
}
</script>
